import React, { Component } from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { history } from './helpers/history';
// import { alertActions } from './actions/alerts';
import { PrivateRoute } from './components/PrivateRoute';
import HomePage from './containers/HomeContainer';
import LoginPage from './containers/LoginContainer';
// import QRContainer from './containers/QRContainer';
import PaymentContainer from './containers/PaymentContainer';
import ChargeTrayContainer from './containers/ChargeTrayContainer';
import CheckBookContainer from './containers/CheckBookContainer';
import PaymentsContainer from './containers/PaymentsContainer';
import CheckbookPayContainer from './containers/CheckbookPayContainer';
import CheckbookChargeContainer from './containers/CheckbookChargeContainer';
import CustomerContainer from './containers/CustomerContainer';
import Pie from './components/Charts/Pie';
import ToolBar from './components/Menu/ToolBar';
import SnackBars from './components/Complements/SnackBars';
import {  deviceDetect } from 'react-device-detect';
import CodesContainer from './containers/CodesContainer';
// import group from "group-reduce";
//import TaxeContainer from './containers/TaxeContainer';
import { links } from './constants/link-constants';
import TransfersContainer from './containers/TransfersContainer';
import UserRegisterContainer from './containers/UserRegisterContainer';
import PasswordChangeContainer from './containers/PasswordChangeContainer';
import IdleTimer from 'react-idle-timer'

import Can from './services/can';
import RecoverContainer from './containers/RecoverContainer';
import { ThemeProvider } from '@material-ui/styles';
import ElectricTaxeContainer from './containers/ElectricTaxeContainer';
import { filterArrayEqual, filterArrayMoreEqual, filterArrayNotEqual, filterArrayNotEqualAccountJoint } from './functions/arrays';
import { orderAccountsVouchers } from './functions/orderaccounts';
import { sendMobile } from './functions/mobile';
import HomeInfoUserMobile from './components/Complements/HomeInfoUserMobile';
import ChangeQuotasContainer from './containers/ChangeQuotasContainer';
import MovementsContainer from './containers/MovementsContainer';
import DepositsContainer from './containers/DepositsContainer';
import CreditsContainer from './containers/CreditsContainer';
import InfoDeviceUser from './components/Home/InfoDeviceUser';
import CreditsPayContainer from './containers/CreditsPayContainer';
import CertificatesContainer from './containers/CertificatesContainer';
import ConsultCertificatesContainer from "./containers/ConsultCertificatesContainer"
import CertificateValidateContainer from './containers/CertificateValidateContainer';
import VoucherTransfertContainer from './containers/VoucherTransfertContainer';
import VoucherCreditsPayContainer from './containers/VoucherCreditsPayContainer';
import VoucherServicePayContainer from './containers/VoucherServicePayContainer';
import VoucherPaymentMeterContainer from './containers/VoucherPaymentMeterContainer';
import ElectronicRechargesContainer from './containers/ElectronicRechargesContainer'
import PaymentServiceSwitchContainer from './containers/PaymentServiceSwitchContainer';
import { themePrimary } from './styles/PrimaryTheme';
import { themeLogin } from './styles/LoginTheme';
import { servicesSocket } from './functions/socket';
import QuestionsContainer from './containers/QuestionsContainer';
import { chargeData } from "./actions/chargeCoreData";
import * as allActions from './functions/loguin-imports'
import ToolbarLogout from './components/Menu/ToolbarLogout';
//import HomeLogoutContainer from './containers/HomeLogoutContainer';
import { CssBaseline } from '@material-ui/core';
import PaymentServiceSwitchSupaContainer from './containers/PaymentServiceSwitchSupaContainer'
import FoundationsContainer from './containers/FoundationsContainer';
import UploadPayRoleContainer from './containers/UploadPayRoleContainer'
import PayRollContainer from './containers/PayRollContainer';
import PayRollActivityContainer from './containers/PayRollActivityContainer';
import { checkPermissionUser } from './functions/permissions-functions';
import TransactionsActivityContainer from './containers/TransactionsActivityContainer';
import QrGeneratesContainer from './containers/QrGeneratesContainer';
const dataDefault = require('./constants/cb-default.json')
// import { reset } from 'redux-form';

function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

/**
 * *** App Component ***
 */
class App extends Component {
    state = {
        openSnackbar: false,
        message: '',
        type: '',
        dataNotification: [],
        codesData: [],
        isTimedOut: true,
        dataDevice : {},
    }

    constructor(props) {
        super(props);

        history.listen((location, action) => {
            for (const link in links) {
                (location.pathname === link) && this.props.setActualPage(links[link])
                // console.log(`links.${link} = ${links[link]}`);
              }
            // clear alert on location change
            // this.props.clearAlerts();
        });
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
    }

    _onAction(e) {
        const {isTimedOut } = this.state
        isTimedOut && this.setState({isTimedOut: false})
        // this.idleTimer.reset();
        if (this.idleTimer) {
            this.idleTimer.reset();
        }
        
    }

    _onActive(e) {
      this.setState({isTimedOut: false})
    }

    _onIdle(e) {
      const { isTimedOut } = this.state
      if (isTimedOut) {        
            this.setOnLogout()
      } else {
        // this.setState({showModal: true})
        this.idleTimer.reset();
        this.setState({isTimedOut: true})
      }

    }

    dataChart = () => {
        const { balances } = this.props
        let result = []
        if (!isEmpty(this.props.user2) && balances.length > 0)  {
            filterArrayNotEqual(balances, 'Tipo', 'CERTIFICADOS DE APORTACION').map(data => {
                return result.push({
                    type: 1,
                    name: `<b>${data.Tipo}: $ ${data.SaldoCuenta}</b>`,
                    y: data.SaldoCuenta
                })
            })

        }
        return result
    }

    fetchFromRemote =()=> console.log('fetchFromRemote')

    RedirectMobile =() => history.push('/password-change')

    componentDidMount() {
        this.setState({ dataDevice: deviceDetect()})
        this.props.setActualPage('Estado de cuenta')
        document.addEventListener("contextmenu", (event) => {
            event.preventDefault();
        });

        if (localStorage.auth) {
          localStorage.clear();
            this.props.loginSuccess().then(({payload, message}) => {
                if (message) {
                    history.push('/home')
                }
                if (payload) {

                servicesSocket(this.props.user, this.props)
                chargeData(this.props, payload).then(res => {
                    //console.log("Validacion app.js", res)
                    this.props.loadingState(true)
                    if(this.props.user.haveQuestions === 0) {
                        history.push('/questions')
                    }else{
                        if(this.props.user.changePass === 0) {
                            history.push('/password-change')
                        }
                    }
                }).catch(err => {
                    this.props.logoutAction()
                    this.props.resetStore()
                    this.props.loadingState(false)
                    history.push('/home')
                })
                //envia al dispositivo
                    let send = {
                        type: 'data',
                        data: payload
                    }
                    sendMobile(JSON.stringify(send))
                }
                !payload.user && history.push('/home')
            }).catch( error => {
            
                this.props.logoutAction()
                this.props.resetStore()
                this.props.loadingState(false)
                history.push('/home')
            })

        } else {
            // console.log('redirige')
            // history.push('/home')
        }
    }

    renderCustomer = () => {
        const { credits, loading, deposits } = this.props
        return  loading ?
                <CodesContainer
                        classes = { this.props }
                        deposits = { deposits}
                        handleOpenSnack = { this.handleOpenSnack }
                        balances = {this.props.balances }
                        credits = { credits } /> :
                        <div></div>
    }

    renderBodyHomeInfoUserMobile = () => {
        if (!isEmpty(this.props.user2) && this.props.balances.length > 0) {

            return <HomeInfoUserMobile
                customer = { this.props.user2 }
                amount = { this.props.balances[0].Saldo }
                accountType = { `${this.props.balances[0].EstadoNombre} - ${this.props.balances[0].TipoCuentaNombre}` }
                authenticate = { this.props.user }
                credits = { this.props.credits}
                balances = { this.props.balances[0]}
                chart = { this.renderChart() }
            />

        } else {

            return <HomeInfoUserMobile skeleton = {true} user = { {} }/>

        }
    }

    renderInfoDeviceUser = () => {
        const { user2, verificates, user } = this.props;

        return <InfoDeviceUser
                    customer = { user2 }
                    verificates = { verificates }
                    user = { user }
                />
    }

    renderInfoCustomer = () => {
        const { loading, balances, deposits, verificates, credits, parameters, getBalanceUser, userPermissions} = this.props
        return loading ?
                <CustomerContainer
                    skeleton = {false}
                    classes = { this.props }
                    authenticate = { this.props.user }
                    // const acc = filterArrayMoreEqual(res.data, 'Tipo', ['AHORRO', 'CORRESPONSALIA', 'CUENTA PREMIUM', 'AHORRO MENORES DE EDAD']);
                    balances = { filterArrayMoreEqual(filterArrayNotEqualAccountJoint(balances, 'Tipo', 'CERTIFICADOS DE APORTACION'), 'Tipo', ['AHORRO', 'CORRESPONSALIA', 'CUENTA PREMIUM', 'AHORRO MENORES DE EDAD', 'AHORRO PROGRAMADO'])}
                    balancesjoint = { filterArrayMoreEqual(filterArrayEqual(balances, 'TipoFirma', 'CONJUNTA'), 'Tipo', ['AHORRO', 'CORRESPONSALIA', 'AHORRO MENORES DE EDAD', 'CUENTA PREMIUM', 'AHORRO PROGRAMADO'])}
                    user = { this.props.user2}
                    deposits = { deposits }
                    credits = { credits}
                    verificates = { verificates}
                    parameters = {parameters}
                    getBalanceUser = {getBalanceUser}
                    userPermissions = { userPermissions }
                    /> :
                <CustomerContainer skeleton = {true} classes = { this.props } user = { {}} />
    }
    renderChart = () => {
        return  <div>
                    {(this.props.balances.length > 0) && <Pie data = { {title: 'Consolidado de cuentas', data: this.dataChart() }} />}
                </div>
    }
    // handle
    handleOncloseSnack = () => {
        this.setState({ openSnackbar: false });
    }
    handleOpenSnack = (message, type) => {
        this.setState({ openSnackbar: true, message, type });
    }

    setOnLogoutClose = async() => {
        this.setState({loading: true})
        let send = {
            type: 'data',
            data: 'logout'
        }
        sendMobile(JSON.stringify(send))
        await this.props.logoutAction()
        await this.props.resetStore()
        await this.props.loadingState(false)
    }

    setOnLogout = () => {
        //console.log('cierra')
        this.setState({loading: false})
        let send = {
            type: 'data',
            data: 'logout'
        }
        sendMobile(JSON.stringify(send))

        this.props.logoutAction()
        this.props.resetStore()
        this.props.loadingState(false)
        this.setState({ isTimedOut: true })
        this.idleTimer.reset();
        history.push('/home')
    }

    onPatchedService = () => {
        // Receive real-time events through Socket.io

    }

  render() {
      const { user, devices, userCodesCharge, checkbook,customers, user2, balances,
        checkbookEmited, authentication, notifications, entitiesCore, institutionsCore,
        metersCore, electricCompaniesCore, deposits, credits, loading, parameters, quotas, getDeviceData, updateIpDevice, agreementsSwitchServices, otherServices, getCertificatesCore, certificates, foundations, payrolls, company, getUsersCompany, states, getStates, userPermissions } = this.props;

        return (
          <div className="jumbotron">
              <div className="container">
                  <div className="col-sm-8 col-sm-offset-2">
        {/* your app here */}
                      {
                          // window.postMessage('hola')
                        // ( localStorage.length === 0) ?
                        ( localStorage.auth === undefined) ?
                        <ThemeProvider theme={themeLogin}>
                            <CssBaseline/>
                            <ToolbarLogout
                                renderContainer = {
                                    <Router history={history}>
                                        <Switch>
                                            {/* <Route path="/home">
                                                <HomeLogoutContainer handleOpenSnack = { this.handleOpenSnack } getDeviceData = {getDeviceData} devices = {devices} updateIpDevice = { updateIpDevice } />
                                            </Route> */}
                                            <Route path="/login">
                                                <LoginPage handleOpenSnack = { this.handleOpenSnack } getDeviceData = {getDeviceData} devices = {devices} updateIpDevice = { updateIpDevice } ></LoginPage>
                                            </Route>
                                            <Route path="/password-recover">
                                                <RecoverContainer handleOpenSnack = { this.handleOpenSnack } recoveryType ={ false } getDeviceData = {getDeviceData} devices = {devices} updateIpDevice = { updateIpDevice }/>
                                            </Route>
                                            <Route path="/user-recover">
                                                <RecoverContainer handleOpenSnack = { this.handleOpenSnack } recoveryType ={ true } getDeviceData = {getDeviceData} devices = {devices} updateIpDevice = { updateIpDevice }/>
                                            </Route>
                                            <Route path="/certificate-validate">
                                                <CertificateValidateContainer handleOpenSnack = { this.handleOpenSnack }  getDeviceData = {getDeviceData} devices = {devices} updateIpDevice = { updateIpDevice }/>
                                            </Route>
                                            <Redirect from="*" to="/login" />
                                        </Switch>
                                    </Router>
                                }
                            />
                        </ThemeProvider>:
                        (authentication.user !== undefined  ) &&
                        <ThemeProvider theme={themePrimary(filterArrayEqual(parameters, 'name', 'PRIMARY_COLOR').length > 0 ? filterArrayEqual(parameters, 'name', 'PRIMARY_COLOR')[0].value : dataDefault.PRIMARY_COLOR )}>
                        <ToolBar
                        onLogout = { this.setOnLogout }
                        onNotification = { this.fetchFromRemote }
                        notifications = { notifications }
                        userState = { user.changePass }
                        userQuestions = { user.haveQuestions }
                        parameters = {parameters}
                        setOnLogoutClose = {this.setOnLogoutClose}
                        timeSession = {
                            <IdleTimer
                                ref={ref => { this.idleTimer = ref }}
                                element={document}
                                onActive={this.onActive}
                                onIdle={this.onIdle}
                                onAction={this.onAction}
                                debounce={250}
                                timeout={filterArrayEqual(this.props.parameters, 'name', 'INACTIVITY_TIME').length > 0 ?  parseInt(filterArrayEqual(this.props.parameters, 'name', 'INACTIVITY_TIME')[0].value) : dataDefault.INACTIVITY_TIME} />
                        }
                        renderContainer = {
                            <Router history={history}>
                                <Switch >
                                        <PrivateRoute exact path="/" >
                                            <HomePage
                                                loading = {loading}
                                                user = { user }
                                                renderBody = { this.renderInfoDeviceUser() }
                                                renderInfoBody = { this.renderChart() }
                                                renderChart = { this.renderInfoCustomer() }
                                                multiple = { true }
                                            />
                                        </PrivateRoute>
                                        <Route exact path = "/QR" >
                                            <HomePage
                                            loading = {loading}
                                                user = { user }
                                                renderBody = {
                                                    this.renderCustomer()
                                                }
                                                renderInfoBody = {this.renderInfoCustomer()}
                                                renderChart = {this.renderChart()}
                                                multiple = { true }
                                            />
                                        </Route>
                                        <Route exact path = "/payment" >
                                            <PaymentContainer
                                                handleOpenSnack = { this.handleOpenSnack }
                                            /></Route>
                                        <Route exact path = "/charges-tray" >
                                            {
                                                user && <ChargeTrayContainer
                                                    user = { user }
                                                    userCodesCharge = { userCodesCharge }
                                                    PaymentType = 'request'
                                                    title = 'Bandeja de Cobros'
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                />
                                            }
                                        </Route>
                                        <Route exact path = "/checkbook" >
                                            <CheckBookContainer handleOpenSnack = { this.handleOpenSnack } />
                                        </Route>
                                        <Route exact path = "/payments" >
                                            <PaymentsContainer
                                                    handleOpenSnack = { this.handleOpenSnack } />
                                            </Route>
                                        <Route exact path = "/checkbook-pays" >
                                            {
                                                user && <CheckbookPayContainer
                                                    user = { user }
                                                    checkbook = { checkbook }
                                                    devices = { devices }
                                                    PaymentType = 'charge'
                                                    title = 'Cobrar cheques'
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    customers = { customers }
                                                />
                                            }
                                        </Route>
                                        <Route exact path = "/checkbook-charge" >
                                            {
                                                (user && checkbookEmited) && <CheckbookChargeContainer
                                                    user = { user }
                                                    checkbookEmited = { checkbookEmited }
                                                    devices = { devices }
                                                    PaymentType = 'cedule'
                                                    title = 'Cobrar cheques'
                                                />
                                            }
                                        </Route>

                                        <Route exact path = "/transfers" >
                                            {
                                                (user &&  balances.length > 0) &&
                                                (checkPermissionUser(userPermissions, 1) || checkPermissionUser(userPermissions, 2)) ?
                                                <TransfersContainer
                                                    user = { this.props.user2 }
                                                    auth = { this.props.user }
                                                    beneficiaries = { this.props.beneficiary}
                                                    balances = { filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM', "CORRESPONSALIA"]), "EstadoNombre", "ACTIVO") }
                                                    entities = { entitiesCore }
                                                    institutions = { institutionsCore }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    quotas = {quotas}
                                                    getQuotas = {this.props.getQuotas}
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    userPermissions ={userPermissions}
                                                />:
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>
                                        <Route exact path = "/user-register" >
                                            {
                                                <Can
                                                    role={user.type}
                                                    perform="users:create"
                                                    yes={() => (
                                                        user &&
                                                        <UserRegisterContainer
                                                            user = { this.props.user2 }
                                                            customers = { this.props.customers }
                                                            handleOpenSnack = { this.handleOpenSnack }/>
                                                    )}
                                                    no={ () => <Redirect to="/" /> }
                                                />
                                            }
                                        </Route>
                                        <Route exact path = "/password-change" >
                                            {
                                                user &&
                                                <PasswordChangeContainer
                                                    user = { this.props.user }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                />
                                            }
                                        </Route>
                                        <Route exact path = "/change-quotas" >
                                            {
                                                user && checkPermissionUser(userPermissions, 5) ?
                                                <ChangeQuotasContainer
                                                    user = { this.props.user }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    quotas = {quotas}
                                                    devices = {devices}
                                                />:
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>
                                        <Route exact path = "/donations-foundations" >
                                            {
                                                user && checkPermissionUser(userPermissions, 23) ?
                                                <FoundationsContainer
                                                    user = { user2 }
                                                    auth = { user }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    devices = {devices}
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayEqual(balances, 'Tipo', 'AHORRO'), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    foundations = { foundations }
                                                />:
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>
                                        <Route exact path = "/questions" >
                                            {
                                                user &&
                                                <QuestionsContainer
                                                    user = { this.props.user }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    usercore = { this.props.user2 }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                />
                                            }
                                        </Route>
                                        <Route exact path = "/electric-taxes" >
                                            {
                                                (user2 && balances.length > 0 && electricCompaniesCore.length > 0) &&
                                                <ElectricTaxeContainer
                                                    user = { user2 }
                                                    auth = { user }
                                                    meters = { metersCore }
                                                    balances = { filterArrayEqual(balances, 'Tipo', 'DEPOSITOS A LA VISTA')}
                                                    companies = { electricCompaniesCore }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                />
                                            }
                                        </Route>
                                        <Route exact path = "/electronic-recharges" >
                                            {
                                                (user2 && balances.length > 0) && checkPermissionUser(userPermissions, 4) ?
                                                <ElectronicRechargesContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'RECARGAS') }
                                                    otherServices = { otherServices }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />:
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>
                                        <Route exact path = "/plan-payment" >
                                            {
                                                (user2 && balances.length > 0) && checkPermissionUser(userPermissions, 4) ?
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'PLANES') }
                                                    type = { "PLANES" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                /> :
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>
                                        <Route exact path = "/electricity-payment" >
                                            {
                                                (user2 && balances.length > 0) && checkPermissionUser(userPermissions, 4) ?
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'LUZ') }
                                                    type = { "LUZ" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />:
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>
                                        <Route exact path = "/telephone-payment" >
                                            {
                                                (user2 && balances.length > 0) && checkPermissionUser(userPermissions, 4) ?
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'TELEFONO') }
                                                    type = { "TELEFONO" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />:
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>
                                        <Route exact path = "/water-payment" >
                                            {
                                                (user2 && balances.length > 0) && checkPermissionUser(userPermissions, 4) ?
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'AGUA') }
                                                    type = { "AGUA" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />:
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>
                                        <Route exact path = "/catalog-payment" >
                                            {
                                                (user2 && balances.length > 0) && checkPermissionUser(userPermissions, 4) ?
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'CATALOGO') }
                                                    type = { "CATALOGO" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />:
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>

                                        <Route exact path = "/iess" >
                                            {
                                                (user2 && balances.length > 0) && checkPermissionUser(userPermissions, 4) ?
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'IESS') }
                                                    type = { "IESS" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />:
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>

                                        <Route exact path = "/sri" >
                                            {
                                                (user2 && balances.length > 0) && checkPermissionUser(userPermissions, 4) ?
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'SRI') }
                                                    type = { "SRI" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />:
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>

                                        <Route exact path = "/judiciary-council" >
                                            {
                                                (user2 && balances.length > 0) && checkPermissionUser(userPermissions, 4) ?
                                                <PaymentServiceSwitchSupaContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'CONSEJO JUDICATURA') }
                                                    type = { "CONSEJO JUDICATURA" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />:
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>

                                        <Route exact path = "/transit" >
                                            {
                                                (user2 && balances.length > 0) && checkPermissionUser(userPermissions, 4) ?
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'TRANSITO') }
                                                    type = { "TRANSITO" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />:
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>

                                        <Route exact path = "/municipalities" >
                                            {
                                                (user2 && balances.length > 0) && checkPermissionUser(userPermissions, 4) ?
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'MUNICIPIO') }
                                                    type = { "MUNICIPIO" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />:
                                                <Redirect from="*" to="/" />
                                            }
                                        </Route>

                                        <Route exact path = "/internet" >
                                            {
                                                (user2 && balances.length > 0) &&
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'INTERNET') }
                                                    type = { "INTERNET" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />
                                            }
                                        </Route>

                                        <Route exact path = "/tv" >
                                            {
                                                (user2 && balances.length > 0) &&
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'TELEVISIÓN') }
                                                    type = { "TELEVISIÓN" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />
                                            }
                                        </Route>

                                        <Route exact path = "/various" >
                                            {
                                                (user2 && balances.length > 0) &&
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'VARIOS') }
                                                    type = { "VARIOS" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />
                                            }
                                        </Route>

                                        <Route exact path = "/shops" >
                                            {
                                                (user2 && balances.length > 0) &&
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'COMERCIOS') }
                                                    type = { "COMERCIOS" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />
                                            }
                                        </Route>

                                        <Route exact path = "/cards" >
                                            {
                                                (user2 && balances.length > 0) &&
                                                <PaymentServiceSwitchContainer
                                                    user = { user2 }
                                                    balances = { filterArrayEqual(filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM',]), "TipoFirma", "INDIVIDUAL"), "EstadoNombre", "ACTIVO") }
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    parameters = { parameters }
                                                    auth = { user }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    agreementsSwitchServices = { filterArrayEqual(agreementsSwitchServices, 'category', 'TARJETA') }
                                                    type = { "TARJETA" }
                                                    otherServices = { otherServices }
                                                    identityAgreement = { "" }
                                                    titleOptionOneMenu = { "Seleccione un número de referencia favorita" }
                                                    titleOptionTwoMenu = { "Agregar un nuevo número de referencia" }
                                                    allAgreementsSwicthServices = { agreementsSwitchServices }
                                                />
                                            }
                                        </Route>

                                        <Route exact path = "/movements/:id"
                                            render = { props => <MovementsContainer
                                                classes = { this.props }
                                                secuencial = {props.match.params.id}
                                            />}
                                        >
                                        </Route>
                                        <Route exact path = "/movements-deposits/:id"
                                            render = { props => {
                                                if (loading) {
                                                    return <DepositsContainer
                                                            classes = { this.props }
                                                            deposits = {deposits}
                                                            secuencial = {props.match.params.id}
                                                            balances = {balances} />
                                                } else return <div>cargando...</div>
                                            }}
                                        ></Route>
                                        <Route exact path = "/movements-credits/:id"
                                            render = { props => <CreditsContainer
                                                classes = { this.props }
                                                credits = {credits}
                                                secuencial = {props.match.params.id}
                                                balances = {balances} />}
                                        ></Route>
                                        <Route exact path = "/credits-pay" >
                                            {
                                                (loading) ? checkPermissionUser(userPermissions, 3) ?
                                                    <CreditsPayContainer
                                                        auth = { user }
                                                        user = { user2 }
                                                        balances = { filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM', 'CORRESPONSALIA']), "EstadoNombre", "ACTIVO")}
                                                        credits = {credits}
                                                        handleOpenSnack = { this.handleOpenSnack }
                                                        parameters = { parameters }
                                                        getDeviceData = {getDeviceData}
                                                        updateIpDevice = { updateIpDevice}
                                                        devices = {devices}
                                                    /> : <Redirect from="*" to="/" /> :
                                                    <div>cargando...</div>
                                            }
                                        </Route>
                                        <Route exact path = "/vouchers-transfert" >
                                            {
                                                (loading) ? checkPermissionUser(userPermissions, 19) ?
                                                    <VoucherTransfertContainer
                                                        user = { user2 }
                                                        classes = { this.props }
                                                        handleOpenSnack = { this.handleOpenSnack }
                                                        balances = {filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM', 'CORRESPONSALIA'])}
                                                    /> : <Redirect from="*" to="/" /> :
                                                    <div>cargando...</div>
                                            }
                                        </Route>
                                        <Route exact path = "/vouchers-credits-pay" >
                                            {
                                                (loading) ? checkPermissionUser(userPermissions, 19) ?
                                                    <VoucherCreditsPayContainer
                                                        user = { user2 }
                                                        classes = { this.props }
                                                        handleOpenSnack = { this.handleOpenSnack }
                                                        balances = {filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM', 'CORRESPONSALIA'])}
                                                    /> : <Redirect from="*" to="/" /> :
                                                    <div>cargando...</div>
                                            }
                                        </Route>
                                        <Route exact path = "/vouchers-service-pay" >
                                            {
                                                (loading) ? checkPermissionUser(userPermissions, 19) ?
                                                    <VoucherServicePayContainer
                                                        user = { user2 }
                                                        classes = { this.props }
                                                        handleOpenSnack = { this.handleOpenSnack }
                                                        balances = {orderAccountsVouchers(balances)}
                                                    /> : <Redirect from="*" to="/" /> :
                                                    <div>cargando...</div>
                                            }
                                        </Route>
                                        <Route exact path = "/vouchers-payment-meter" >
                                            {
                                                (loading) ?
                                                    <VoucherPaymentMeterContainer
                                                        user = { user2 }
                                                        classes = { this.props }
                                                        handleOpenSnack = { this.handleOpenSnack }
                                                        balances = {orderAccountsVouchers(balances)}
                                                    /> :
                                                    <div>cargando...</div>
                                            }
                                        </Route>
                                        <Route exact path = "/certificates" >
                                            {
                                                (loading) ? checkPermissionUser(userPermissions, 22) ?
                                                    <CertificatesContainer
                                                        getCertificatesCore = {getCertificatesCore}
                                                        certificates = { certificates }
                                                        user = { user2 }
                                                        auth = { user }
                                                        classes = { this.props }
                                                        handleOpenSnack = { this.handleOpenSnack }
                                                        balances = { filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM', 'CORRESPONSALIA']), "EstadoNombre", "ACTIVO")}
                                                        parameters = {parameters}
                                                        devices = {devices}
                                                        credits = { credits}
                                                        deposits = { deposits}
                                                    /> : <Redirect from="*" to="/" /> :
                                                    <div>cargando...</div>
                                            }
                                        </Route>
                                        <Route exact path = "/consult-certificates" >
                                            {
                                                (loading) ? checkPermissionUser(userPermissions, 17) ?
                                                    <ConsultCertificatesContainer
                                                        getCertificatesCore = {getCertificatesCore}
                                                        certificates = { certificates }
                                                        parameters = {parameters}
                                                        user = { user2 }
                                                        auth = { user }
                                                        classes = { this.props }
                                                        handleOpenSnack = { this.handleOpenSnack }
                                                        balances = {filterArrayEqual(filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CUENTA PREMIUM', 'CORRESPONSALIA']), "EstadoNombre", "ACTIVO")}
                                                    /> : <Redirect from="*" to="/" /> :
                                                    <div>cargando...</div>
                                            }
                                        </Route>
                                        <Route exact path = "/upload-pay-role" >
                                            {
                                                (user &&  balances.length > 0 &&  isEmpty(!payrolls) && checkPermissionUser(userPermissions, 11)) ?
                                                <UploadPayRoleContainer
                                                    getStates = {getStates}
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    balances = { balances }
                                                    company = {company }
                                                    user = { user }
                                                    parameters = { parameters }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    quotas = {quotas}
                                                    updateIpDevice = { updateIpDevice }
                                                    getUsersCompany = { getUsersCompany }
                                                /> : <Redirect from="*" to="/" />
                                            }
                                        </Route>
                                        <Route exact path = "/payment-pay-role" >
                                            {
                                                (user && checkPermissionUser(userPermissions, 10)) ?
                                                <PayRollContainer
                                                    getStates = {getStates}
                                                    states = {states}
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    balances = { balances }
                                                    user = { user }
                                                    company = {company }
                                                    parameters = { parameters }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    classes = { this.props }
                                                    quotas = {quotas}
                                                /> : <Redirect from="*" to="/" />
                                            }
                                        </Route>
                                        <Route exact path = "/activities-pay-role" >
                                            {
                                                (user && checkPermissionUser(userPermissions, 12)) ?
                                                <PayRollActivityContainer
                                                    states = {states}
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    balances = { balances }
                                                    user = { user }
                                                    company = {company }
                                                    parameters = { parameters }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    classes = { this.props }
                                                    quotas = {quotas}
                                                /> : <Redirect from="*" to="/" />
                                            }
                                        </Route>
                                        <Route exact path = "/activities-transactions" >
                                            {
                                                (user && ( checkPermissionUser(userPermissions, 25) || checkPermissionUser(userPermissions, 26))) ?
                                                <TransactionsActivityContainer
                                                    states = {states}
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    balances = { balances }
                                                    user = { user }
                                                    company = {company }
                                                    parameters = { parameters }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    classes = { this.props }
                                                    quotas = {quotas}
                                                /> : <Redirect from="*" to="/" />
                                            }
                                        </Route>
                                        <Route exact path = "/qr-generator" >
                                            {
                                                <QrGeneratesContainer
                                                    states = {states}
                                                    handleOpenSnack = { this.handleOpenSnack }
                                                    balances = { balances }
                                                    user = { user }
                                                    company = {company }
                                                    parameters = { parameters }
                                                    getDeviceData = {getDeviceData}
                                                    devices = {devices}
                                                    updateIpDevice = { updateIpDevice }
                                                    classes = { this.props }
                                                    quotas = {quotas}
                                                /> 
                                            }
                                        </Route>
                                        {<Redirect from="*" to="/" />
                                        }
                                </Switch>
                            </Router>

                        } />
                        </ThemeProvider>
                      }
                    <SnackBars
                        {...this.state}
                        oncloseSnack = { this.handleOncloseSnack }
                    />
                  </div>
              </div>
          </div>
      );
  }
}


const mapDispatchToProps = state => {
  const { authentication, devices, userCodes, userCodesCharge, checkbook,
    customers, codes, checkbookEmited, navigation, notifications, balances, beneficiary,
    credits, entitiesCore, institutionsCore, electricCompaniesCore, metersCore, periodsCore,
    levelsCore, agreements, loading, deposits, verificates, parameters, quotas, siim, agreementTypes, agreementsSwitchServices, foundations, otherServices, certificates, payrolls, company, states, userPermissions } = state
  const user2 = state.user
  const { user } = authentication
  return { user, devices, userCodes, userCodesCharge, checkbook,
    customers, authentication, user2, codes, checkbookEmited, navigation,
    notifications, balances, beneficiary, credits, entitiesCore, institutionsCore,
    electricCompaniesCore, metersCore, periodsCore, levelsCore, agreements, loading, deposits, verificates, parameters, quotas, siim, agreementTypes, agreementsSwitchServices, foundations, otherServices, certificates, payrolls, company, states, userPermissions };
}

export default connect(mapDispatchToProps, {...allActions} )(App)
